import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export type UserRole = 'admin' | 'user' | 'client';

export function useUserRole() {
  const [userRole, setUserRole] = useState<UserRole>('client');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getUserRole() {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        
        if (!user) {
          console.log('🔐 No user found, setting role to client');
          setUserRole('client');
          setLoading(false);
          return;
        }

        // For now, we'll use a simple role check based on user metadata
        // In a real implementation, this would query the user_roles table
        const role = user.user_metadata?.role as UserRole || 'client';
        console.log('🔐 User found:', user.email, 'Role:', role);
        setUserRole(role);
      } catch (error) {
        console.error('🔐 Error fetching user role:', error);
        setUserRole('client');
      } finally {
        setLoading(false);
      }
    }

    getUserRole();
  }, []);

  const canViewDocuments = userRole === 'admin' || userRole === 'user';
  console.log('🔐 Hook result - userRole:', userRole, 'canViewDocuments:', canViewDocuments);
  
  return { userRole, loading, isAdmin: userRole === 'admin', canViewDocuments };
}